import React from "react";
import InvoiceIcon from "../sharedComponents/InvoiceIcon";

const CustomBuyForMeButtonOrders = ({
  children,
  onClick,
  icon: Icon,
  bgColor = "bg-custom-yellow",
  textColor = "text-black",
  iconColor = "text-black",
  direction,
}) => {
  // console.log(direction)
  return (
    <div className="flex items-center justify-center mt-5 mb-3" dir={direction}>
      <button
        onClick={onClick}
        className={`${bgColor} ${textColor} py-2 px-2 lg:py-3 lg:px-6 rounded-custom
                    text-xs  lg:text-sm inline-flex items-center justify-center
                    transition duration-300 ease-in-out transform hover:scale-105 
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color 
                    whitespace-nowrap`}
      >
        {children}
        {Icon && (
          <>
            {Icon === InvoiceIcon ? (
              <InvoiceIcon bgColor={"white"} />
            ) : (
              <Icon
                className={`w-4 ${iconColor} ms-2 ${
                  direction === "ltr" && "rotate-180"
                }`}
              />
            )}
          </>
        )}
      </button>
    </div>
  );
};

export default CustomBuyForMeButtonOrders;
